import { Button } from '@eventbrite/marmalade';
import React, { FunctionComponent } from 'react';
import { CTA_JOIN_WAITLIST } from '../../../constants';
import { TicketContentProps } from '../TicketContent';

export type TicketJoinWaitlistButtonProps = Pick<
    TicketContentProps,
    'onJoinWaitlist' | 'id'
>;

export const TicketJoinWaitlistButton: FunctionComponent<
    TicketJoinWaitlistButtonProps
> = ({ onJoinWaitlist, id }) => {
    const onJoinWaitlistFn = onJoinWaitlist ? onJoinWaitlist : undefined;
    return (
        <div
            className="eds-ticket-card-content__join-waitlist-button"
            data-spec="join-waitlist-button"
            data-testid="join-waitlist-button"
            data-automation={`join-waitlist-ticket-${id}-btn`}
        >
            <Button onClick={onJoinWaitlistFn}>{CTA_JOIN_WAITLIST}</Button>
        </div>
    );
};
